import { DASHBOARD_LABELS } from 'src/common/labels/dashboard.labels';

export const HEADER = {
	title: DASHBOARD_LABELS.MOBILE_DASHBOARD_TITLE,
	showMobileBanner: true,
	showLastUpdated: true
};
